import React from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import TrashIcon from 'assets/icon/dynamic/TrashIcon';

const FIELD_TYPE_LABELS = {
  TextField: 'Text Field',
  MediaField: 'Media Field',
  MediaList: 'Media List',
  DatePicker: 'Date Picker',
  Poi: 'Tenants'
};

function FieldList({ fields, onDragEnd, onEdit, onDelete, onToggleScheduling }) {
  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="master-config-fields">
        {(provided) => (
          <div
            className="dynamic-comp-field-list"
            ref={provided.innerRef}
            {...provided.droppableProps}
          >
            {fields.map((field, index) => (
              <Draggable
                key={field._id || `temp-${field._tempId}`}
                draggableId={field._id || `temp-${field._tempId}`}
                index={index}
              >
                {(provided) => (
                  <div
                    className="dynamic-comp-field-card"
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                  >
                    <div
                      className="dynamic-comp-field-drag-handle"
                      {...provided.dragHandleProps}
                    >
                      <i className="feather-menu" />
                    </div>
                    <div className="dynamic-comp-field-content">
                      <span className="dynamic-comp-field-type">
                        {FIELD_TYPE_LABELS[field.fieldType] || field.fieldType}
                      </span>
                      <h4 className="dynamic-comp-field-label">
                        {field.label}
                      </h4>
                      <p className="dynamic-comp-field-desc">
                        {field.description}
                      </p>
                    </div>
                    <div className="dynamic-comp-field-actions">
                      {field.fieldType === 'DatePicker' && (
                        <label className="dynamic-comp-scheduling-toggle">
                          <span className="dynamic-comp-scheduling-label">
                            Set as Scheduling Reference
                          </span>
                          <input
                            type="checkbox"
                            checked={!!field.setAsScheduling}
                            onChange={() => onToggleScheduling(field)}
                          />
                          <span className="dynamic-comp-radio-custom" />
                        </label>
                      )}
                      <div
                        className="dynamic-comp-field-action"
                        onClick={() => onEdit(field)}
                      >
                        <i className="feather-sliders" />
                      </div>
                      <div
                        className="dynamic-comp-field-action"
                        onClick={() => onDelete(field)}
                      >
                        <TrashIcon color="#e74c3c" size={18} />
                      </div>
                    </div>
                  </div>
                )}
              </Draggable>
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
}

export default FieldList;
